import SearchEmailHtml from './templates/search-email.html';

export function EmailVendorInvoiceCtrl (
  $scope,
  $uibModal,
  $uibModalInstance,
  blockUI,
  email,
  invoice,
  messages,
  messengerApi,
  templatedWording,
  workshopAPI
) {
  $scope.block   = blockUI.instances.get('emailBlock');
  $scope.email   = email;
  $scope.invoice = invoice;

  $scope.send = function () {
    $scope.block.start();

    return messengerApi.sendEmail($scope.email, {
      bodyParamName: 'vendor',
      url          : '/vendor_invoice/email_vendor_invoice'
    })
    .then(() => {
      $uibModalInstance.close();
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.addEmails = function () {
    $uibModal.open({
      controller : 'SearchEmailAddressModalCtrl',
      templateUrl: SearchEmailHtml,
      windowClass: 'lg-modal',
      resolve    : {
        emails: () => workshopAPI.get('/vendors/email_list', $scope.email.id)
      }
    }).result
    .then(data => {
      let emails = $scope.email.email ? `${ $scope.email.email }; ` : '';

      emails += data
      .map(elem => elem.email)
      .join('; ');

      $scope.email.email = emails;
    });
  };

  $scope.addTemplates = function () {
    templatedWording.addTemplate('email')
    .then(templates => {
      angular.forEach(templates, template => {
        if ($scope.email.message) {
          $scope.email.message = `${ $scope.email.message }\n\n${ template.wording }`;
        }
        else {
          $scope.email.message = template.wording;
        }
      });
    });
  };
}
